// Derive US state + county for a drawn boundary by matching its center point
// against county bounding boxes. Classification is by center point only
// (a long corridor spanning counties resolves to whichever county holds its
// midpoint) — intentionally simple for now.
import { COUNTY_BBOX } from "@/components/admin/directory/counties.js";

export const STATE_NAMES = {
  AK: "Alaska", AL: "Alabama", AR: "Arkansas", AZ: "Arizona", CA: "California",
  CO: "Colorado", CT: "Connecticut", DC: "District of Columbia", DE: "Delaware",
  FL: "Florida", GA: "Georgia", HI: "Hawaii", IA: "Iowa", ID: "Idaho",
  IL: "Illinois", IN: "Indiana", KS: "Kansas", KY: "Kentucky", LA: "Louisiana",
  MA: "Massachusetts", MD: "Maryland", ME: "Maine", MI: "Michigan",
  MN: "Minnesota", MO: "Missouri", MS: "Mississippi", MT: "Montana",
  NC: "North Carolina", ND: "North Dakota", NE: "Nebraska", NH: "New Hampshire",
  NJ: "New Jersey", NM: "New Mexico", NV: "Nevada", NY: "New York", OH: "Ohio",
  OK: "Oklahoma", OR: "Oregon", PA: "Pennsylvania", RI: "Rhode Island",
  SC: "South Carolina", SD: "South Dakota", TN: "Tennessee", TX: "Texas",
  UT: "Utah", VA: "Virginia", VT: "Vermont", WA: "Washington", WI: "Wisconsin",
  WV: "West Virginia", WY: "Wyoming",
};

function centroid(boundary) {
  if (!boundary || boundary.length === 0) return null;
  const lat = boundary.reduce((s, p) => s + p[0], 0) / boundary.length;
  const lng = boundary.reduce((s, p) => s + p[1], 0) / boundary.length;
  return [lat, lng];
}

function inBox([lat, lng], [minLat, minLng, maxLat, maxLng]) {
  return lat >= minLat && lat <= maxLat && lng >= minLng && lng <= maxLng;
}

// Classify a [lat,lng] point → { abbr, state, county } (values null if unknown).
export function classifyPoint(point) {
  if (!point) return { abbr: null, state: null, county: null };
  let best = null;
  let bestArea = Infinity;
  for (const [abbr, counties] of Object.entries(COUNTY_BBOX)) {
    for (const c of counties) {
      if (!inBox(point, c.bbox)) continue;
      const [minLat, minLng, maxLat, maxLng] = c.bbox;
      const area = (maxLat - minLat) * (maxLng - minLng);
      if (area < bestArea) { bestArea = area; best = { abbr, county: c.name }; }
    }
  }
  if (!best) return { abbr: null, state: null, county: null };
  return { abbr: best.abbr, state: STATE_NAMES[best.abbr] || best.abbr, county: best.county };
}

// Classify a bike-path/zone boundary (array of [lat,lng]) by its center point.
export function classifyBoundary(boundary) {
  return classifyPoint(centroid(boundary));
}
